import React from 'react';
import ExerciseInterface from './ExerciseSystem/ExerciseInterface';
import { M02_TOPICS, M02_MODULE_INFO } from '../data/mathExercises/M02_Identities';
import { getAllM02Problems } from '../data/mathExercises/M02_ProblemsData';

const M02IdentitiesExercise = ({ onProgress }) => {
  const topics = M02_TOPICS;
  const problems = getAllM02Problems();
  const moduleInfo = M02_MODULE_INFO;

  return (
    <ExerciseInterface
      moduleInfo={moduleInfo}
      topics={topics}
      problems={problems}
      onProgress={onProgress}
      className="m02-exercise"
    />
  );
};

export default M02IdentitiesExercise; 